import React from "react";
import { useTranslation } from "react-i18next";
import FeedbackModal from "../feedback/FeedbackModal";

const ArsenalInfoModal = ({
  show,
  onHide,
  onEnableDisable,
  enable,
  onDelete,
  isReadOnly,
}) => {
  const { t } = useTranslation();

  return (
    <FeedbackModal
      show={show}
      onHide={onHide}
      severity="neutral"
      title={t("arsenalInfoModal.title")}
      secondaryAction={{
        label: enable
          ? t("arsenalInfoModal.disable")
          : t("arsenalInfoModal.enable"),
        onClick: () => onEnableDisable && onEnableDisable(!enable),
      }}
      primaryAction={
        isReadOnly
          ? null
          : {
              label: t("arsenalInfoModal.delete"),
              onClick: () => onDelete && onDelete(),
              variant: "danger",
            }
      }
    />
  );
};

export default ArsenalInfoModal;
